export const XeroParent = {
  REVENUE: 'REVENUE',
  OTHER: 'OTHER',
  OTHER_INCOME: 'OTHERINCOME',
  FIXED: 'FIXED',
  INVENTORY: 'INVENTORY',
  SALES: 'SALES',
  EQUITY: 'EQUITY',
  DIRECT_COSTS: 'DIRECTCOSTS',
}

export const xeroSalesParents = [
  XeroParent.REVENUE,
  XeroParent.SALES,
  XeroParent.OTHER_INCOME,
]

export const getXeroInvoiceDeepLinkUrl = (shortCode, creditNote, accountingInvoiceId) => {
        return creditNote
            ? `https://go.xero.com/AccountsReceivable/EditCreditNote.aspx?creditNoteID=${accountingInvoiceId}`
            : `https://go.xero.com/organisationlogin/default.aspx?shortcode=${shortCode}&redirecturl=/AccountsReceivable/View.aspx?InvoiceID=${accountingInvoiceId}`
}

export const getXeroBillDeepLink = (isCreditNote, accountingInvoiceId) => {
    return isCreditNote
        ? `https://go.xero.com/AccountsPayable/EditCreditNote.aspx?creditNoteID=${accountingInvoiceId}`
        : `https://go.xero.com/AccountsPayable/Edit.aspx?invoiceID=${accountingInvoiceId}`
}
